import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import * as Yup from "yup";

import {
  AddPrescriptionCard,
  createDefaultPrescription,
  VALIDATION_SCHEMA,
} from "../../../patient/_lib/add-prescription-card";

const VALIDATION = Yup.object({
  prescriptions: Yup.array().of(VALIDATION_SCHEMA).required(),
});
type FormValues = Yup.InferType<typeof VALIDATION>;

export const Form: FC<{
  patientWeight: string;
  patientAllergies: string[];
}> = ({ patientWeight, patientAllergies }) => {
  const formMethods = useForm<FormValues>({
    defaultValues: {
      prescriptions: [],
    },
    resolver: yupResolver(VALIDATION),
  });
  const prescriptionFields = useFieldArray({
    control: formMethods.control,
    name: "prescriptions",
  });

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit((_data) => {})}>
        <ul data-testid="prescriptions">
          {prescriptionFields.fields.map((field, index) => (
            <li key={field.id}>
              <AddPrescriptionCard
                patientWeight={patientWeight}
                patientAllergies={patientAllergies}
                onDelete={() => prescriptionFields.remove(index)}
                fieldNames={{
                  clinicalProductId: `prescriptions.${index}.clinicalProductId`,
                  clinicalProductType: `prescriptions.${index}.clinicalProductType`,
                  freeTextProduct: `prescriptions.${index}.freeTextProduct`,
                  howItsTaken: `prescriptions.${index}.howItsTaken`,
                  doseValue: `prescriptions.${index}.doseValue`,
                  doseUnit: `prescriptions.${index}.doseUnit`,
                  rateValue: `prescriptions.${index}.rateValue`,
                  rateUnit: `prescriptions.${index}.rateUnit`,
                  howLongForValue: `prescriptions.${index}.howLongForValue`,
                  howLongForUnit: `prescriptions.${index}.howLongForUnit`,
                  note: `prescriptions.${index}.note`,
                }}
              />
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={() => prescriptionFields.append(createDefaultPrescription())}
        >
          Add prescription
        </button>
      </form>
      <pre>{JSON.stringify(formMethods.watch(), null, 2)}</pre>
    </FormProvider>
  );
};
